import React, { PureComponent } from 'react';
import Select from 'fe-design-base/atoms/Select';
import PropTypes from 'prop-types';

const ordinalSuffixOf = int =>
  `${int}${['st', 'nd', 'rd'][int.toString().match(/1?\d\b/) - 1] || 'th'}`;

const LAST_DAY = { value: -1, label: 'last day' };
const FULL_MONTH_DAYS = 31;

export default class DayOfMonthSelectInput extends PureComponent {
  static propTypes = {
    noOfDays: PropTypes.number,
    includeLastDay: PropTypes.bool,
    cycle: PropTypes.bool,
    startDay: PropTypes.number,
    noOfDaysAfterStartDay: PropTypes.number,
  };

  dayOptions() {
    // if noOfDays is higher than 31, default it to 31
    const noOfDays = this.props.noOfDays > 31 ? 31 : this.props.noOfDays;
    let options = [...Array(noOfDays || FULL_MONTH_DAYS).keys()].map(i => ({
      value: i + 1,
      label: ordinalSuffixOf(i + 1),
    }));

    // include last day only if the month is below 31 day
    options =
      this.props.includeLastDay && options.length < FULL_MONTH_DAYS
        ? options.concat(LAST_DAY)
        : options;

    let optionsWithStartDay;

    // slice the days list to start with the custom passed startDay
    if (this.props.startDay) {
      optionsWithStartDay = options.slice(
        // if the start day is higher than the number of month days, start from day 1
        (this.props.startDay % options.length) - 1,
        options.length
      );
    }

    // - if startDay and noOfDaysAfterStartDay are passed
    //    we will limit the number of days returning to the user
    // - if noOfDaysAfterStartDay is less than the number of days
    //    we have in optionsWithStartDay we will return a list
    //    starting from the start date and have noOfDaysAfterStartDay number of days
    //    ex:
    //      noOfDaysAfterStartDay = 5
    //      startDay = 20
    //      result => [20, 21, 22, 23, 24]
    // - if noOfDaysAfterStartDay is higher than the number of days we have in optionsWithStartDay
    //    we will only return the remaining days from list,
    //    ex:
    //      noOfDaysAfterStartDay = 5
    //      startDay = 29
    //      result => [29, 30, 31]
    //    unless if cycle prop is true we will start from the
    //    beginning of the list till we reach the number of days
    //    ex:
    //      noOfDaysAfterStartDay = 5
    //      startDay = 29
    //      cycle = true
    //      result => [29, 30, 31, 1, 2]
    if (this.props.startDay && this.props.noOfDaysAfterStartDay) {
      const first_chunk = optionsWithStartDay.slice(
        0,
        this.props.noOfDaysAfterStartDay
      );

      let second_chunk = [];

      if (
        first_chunk.length < this.props.noOfDaysAfterStartDay &&
        this.props.cycle
      ) {
        second_chunk = options.slice(
          0,
          this.props.noOfDaysAfterStartDay - optionsWithStartDay.length
        );
      }

      return [...first_chunk, ...second_chunk];
    }

    return optionsWithStartDay || options;
  }

  render() {
    return <Select {...this.props} options={this.dayOptions()} />;
  }
}
